export default __webpack_public_path__ + "static/media/Marquise.9926dbe2.png";